module.exports = __webpack_public_path__ + "static/media/no-photo.f6aaee92.png";